<template>
  <b-card>
    <b-table
      :fields="fields"
      :items="GET_FLATS"
      @row-clicked="itemClicked"
    >
      <template #head()="data">
        <span >{{ $t(data.label) }}</span>
      </template>
      <template #empty>
        <div class="text-center">{{ $t('general.no_records_to_show') }}</div>
      </template>
      <template #cell(status)="props">
        <b-badge
          class="p-50"
          :variant="props.item.current_status.color"
        >
          <!-- {{ ' ' }} -->
          <span v-if="props.item.current_status.title">
            {{ props.item.current_status.title[$i18n.locale] }}
          </span>
        </b-badge>
        <!-- <span v-if="props.item.current_status.title">
          {{ props.item.current_status.title[$i18n.locale] }}
        </span> -->
      </template>
      <template #cell(total_price)="props">
        {{ $_moneyFormatter(props.item.total_price) }}
      </template>
      <template #cell(price_for_square_meter)="props">
        {{ $_moneyFormatter(props.item.price_per_kv) }}
      </template>
    </b-table>
    <div class="d-flex justify-content-between flex-wrap">
      <div class="d-flex align-items-center mb-0 mt-1">
        <span class="text-nowrap">{{ $t('generals.show') }} </span>
        <b-form-select
          v-model="query_params.pageSize"
          :options="[3, 5, 10]"
          class="mx-1"
          @change="$emit('changePerPage', query_params.pageSize)"
        />
        <span class="text-nowrap">
          {{ $t('objects.from') }} {{ GET_FLATS_COUNT }}
        </span>
        <!-- из {{ props.total }} -->
      </div>
      <div>
        <b-pagination
          v-model="query_params.page"
          :total-rows="GET_FLATS_COUNT"
          :per-page="query_params.pageSize"
          first-number
          last-number
          align="right"
          prev-class="prev-item"
          next-class="next-item"
          class="mt-1 mb-0"
          @change="changePage"
        />
      </div>
    </div>
  </b-card>
</template>

<script>
import {
  BTable, BBadge, BFormSelect, BPagination, BCard,
} from 'bootstrap-vue'
import { mapActions, mapGetters } from 'vuex'
import formatters from '@/mixins/extra'

export default {
  components: {
    BTable,
    BBadge,
    BFormSelect,
    BPagination,
    BCard,
  },
  mixins: [formatters],
  props: {
    flats: {
      type: Array,
      required: false,
      default() {
        return []
      },
    },
    query_params: {
      type: Object,
      required: false,
      default() {
        return {
          pageSize: 5,
          page: 1,
        }
      },
    },
  },
  data() {
    return {
      def_query_params: {
        pageSize: 5,
      },
      fields: [
        {
          key: 'flat_number',
          label: 'objects.number_of_the_room',
        },
        {
          key: 'stage_floor',
          label: 'objects.floor',
        },
        {
          key: 'section_title',
          label: 'objects.entrance',
        },
        {
          key: 'price_for_square_meter',
          label: 'objects.price_per_m',
        },
        {
          key: 'rooms_count',
          label: 'objects.numbers_room',
        },
        {
          key: 'total_area',
          label: 'objects.area',
        },
        {
          key: 'total_price',
          label: 'objects.selling_price',
        },
        {
          key: 'status',
          label: 'objects.status',
        },
      ],
    }
  },
  computed: {
    ...mapGetters('flats', ['GET_FLATS', 'GET_FLATS_COUNT']),
  },
  methods: {
    ...mapActions('flats', ['FETCH_FLATS_BY_APARTMENT']),
    changePage(val) {
      console.log(val)
      this.$emit('changePage', val)
    },
    changePerPage(val) {
      console.log(val)
    },
    itemClicked(item) {
      this.$emit('rowItemClicked', item)
    },
  },
}
</script>

<style>

</style>
